import {useTheme} from "@mui/material";
import {observer} from 'mobx-react';
import {useNavigate} from "react-router-dom";
import * as React from "react";
import FormEmailField from "../../../components/fields/FormEmailField";
import FormRow from "../../../forms/FormRow";
import FormSection from "../../../forms/FormSection";
import LayoutContentToolbar from "../../../components/layout/LayoutContentToolbar";
import {USERS_PATH} from "../../../routes";
import FilledButton from "../../../components/buttons/FilledButton";
import LayoutContentWrapper from "../../../components/layout/LayoutContentWrapper";
import {useApplication} from "../../../ApplicationProvider";
import {useNavigatorFeature} from "../../../useFeature";
import {styles} from "../../orders/create_order/CreateOrderStyles";


function CreateUserScreen({featureClass}) {
    const application = useApplication();
    const theme = useTheme();
    const navigator = useNavigate();
    const feature = useNavigatorFeature(() => new featureClass(application, navigator), navigator);
    const style = styles(theme);

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    const userForm = () => {
        return (
            <FormSection title="Usuario">
                <FormRow>
                    <FormEmailField label="Dirección de email" field={feature.form.getFieldByName("email")}/>
                </FormRow>
            </FormSection>
        )
    }
    const createUserContent = () => {
        return isFeatureReady(feature) && (
            <div>
                <LayoutContentToolbar
                    title="Crear Usuario"
                    breadcrumbs={[
                        {label: 'Usuarios Marketplace', path: USERS_PATH},
                        {label: 'Crear usuario'},
                    ]}
                />

                {userForm()}

                <div style={style.buttonsContainer}>
                    <FilledButton disabled={!feature.isFormValid} onClick={() => feature.createUser()}>
                        Crear Usuario
                    </FilledButton>
                </div>
            </div>
        )
    }

    return (
        <LayoutContentWrapper isLoading={!isFeatureReady(feature)} renderContent={() => createUserContent()}/>
    );
}

export default observer(CreateUserScreen);
